import {NgModule} from '@angular/core';
import {Router, RouterModule} from '@angular/router';
import {MenuService} from '../core/menu/menu.service';
import {SharedModule} from '../shared/shared.module';
import {PagesModule} from './pages/pages.module';
import {
  MatButtonModule,
  MatDatepickerModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatTabsModule
} from '@angular/material';


import {menu, menuSimple} from './menu';
import {routes} from './routes';
import {TranslatorService} from "../core/translator/translator.service";
import {GridModule} from '@syncfusion/ej2-angular-grids';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {MatExpansionModule} from "@angular/material/expansion";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatCardModule} from "@angular/material/card";
import {NgxCurrencyModule} from "ngx-currency";
import {MatChipsModule} from "@angular/material/chips";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatDividerModule} from "@angular/material/divider";
import {AutomacoesComponent} from "./automacoes/automacoes.component";
import {TreeModule} from "angular-tree-component";
import {TreeGridModule} from "@syncfusion/ej2-angular-treegrid";
import {MatSelectInfiniteScrollModule} from "ng-mat-select-infinite-scroll";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import { FolhaEsocialComponent } from './folha-esocial/folha-esocial.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {PipesModule} from "../../util/pipes/pipes.module";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {CheckPermission} from "../../service/checkPermission";

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes),
        PagesModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatButtonModule,
        MatDatepickerModule,
        MatSelectModule,
        MatMenuModule,
        MatTabsModule,
        MatIconModule,
        GridModule,
        NgxSkeletonLoaderModule,
        MatExpansionModule,
        MatSlideToggleModule,
        MatCardModule,
        NgxCurrencyModule,
        MatChipsModule,
        MatTooltipModule,
        MatDividerModule,
        TreeModule,
        TreeGridModule,
        MatSelectInfiniteScrollModule,
        NgxMatSelectSearchModule,
        MatCheckboxModule,
        PipesModule,
        MatAutocompleteModule,
    ],
  exports: [
    RouterModule
  ],
  declarations: [AutomacoesComponent, FolhaEsocialComponent],
})

export class RoutesModule {
  constructor(public menuService: MenuService, tr: TranslatorService, public checkPermission: CheckPermission, public router: Router) {
    const officeId = (() => {
      try {
        const data = JSON.parse(localStorage.getItem("id_token_claims_obj"));
        if (!data || !data.details || !data.details.office) {
          this.router.navigate(['/login']);
          return "";
        }
        return data.details.office.id.toString();
      } catch {
        this.router.navigate(['/login']);
        return "";
      }
    })();

    if(officeId === "1656" && !this.checkPermission.isSuperuser()){
      menuService.addMenu(menuSimple, 1);
    } else {
      menuService.addMenu(menu, 1);
    }
  }

}
